import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Instagram, Facebook } from "lucide-react";
import { CONTACT } from "../../data";

const LINKS = [
  { label: "Serviços", href: "#servicos" },
  { label: "História", href: "#historia" },
  { label: "Trabalhos", href: "#trabalhos" },
  { label: "Instagram", href: "#instagram" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 left-0 right-0 z-50"
      data-testid="site-nav"
    >
      <div className={`mx-auto max-w-[1400px] px-5 md:px-10 mt-3 md:mt-4 transition-[background,box-shadow] duration-500 ${scrolled ? "glass rounded-full shadow-[0_8px_32px_rgba(0,47,171,0.08)]" : "bg-transparent"}`}>
        <nav className="flex items-center justify-between h-16 px-2 md:px-4">
          <a href="#top" className="font-display font-extrabold text-lg tracking-tight text-ink" data-testid="nav-logo">
            O Fernando dos Vidros<span className="text-royal">.</span>
          </a>

          <div className="hidden md:flex items-center gap-9">
            {LINKS.map((l) => (
              <a key={l.href} href={l.href} className="link-underline text-sm font-medium text-ink/80 hover:text-ink" data-testid={`nav-link-${l.href.slice(1)}`}>
                {l.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="hidden sm:grid place-items-center h-10 w-10 rounded-full border border-ink/10 hover:border-royal hover:text-royal transition-colors" data-testid="nav-instagram">
              <Instagram size={18} />
            </a>
            <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="hidden sm:grid place-items-center h-10 w-10 rounded-full border border-ink/10 hover:border-royal hover:text-royal transition-colors" data-testid="nav-facebook">
              <Facebook size={18} />
            </a>
            <a href="#marcacao" className="hidden sm:inline-flex items-center rounded-full bg-royal text-white text-sm font-semibold px-5 h-10 hover:bg-[#003380] transition-colors" data-testid="nav-book-btn">
              Fazer marcação
            </a>
            <button onClick={() => setOpen(!open)} className="md:hidden grid place-items-center h-10 w-10 rounded-full border border-ink/10" data-testid="nav-mobile-toggle">
              {open ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </nav>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="md:hidden mx-5 mt-2 glass rounded-3xl p-6 flex flex-col gap-4"
            data-testid="nav-mobile-menu"
          >
            {LINKS.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-lg font-display font-medium text-ink">
                {l.label}
              </a>
            ))}
            <a href="#marcacao" onClick={() => setOpen(false)} className="mt-2 inline-flex justify-center items-center rounded-full bg-royal text-white font-semibold px-5 h-12">
              Fazer marcação
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
